import { render, staticRenderFns } from "./gc-base-layout.vue?vue&type=template&id=5360fdad"
import script from "./gc-base-layout.vue?vue&type=script&lang=js"
export * from "./gc-base-layout.vue?vue&type=script&lang=js"
import style0 from "./gc-base-layout.vue?vue&type=style&index=0&id=5360fdad&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports